// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3DTgL","wrapper":"_3f6jp","topSection":"_3ayuv","heading":"_1eKDo","carDetail":"mfEja","sliderContainer":"_3Y5Mz","uploadText":"aUuUr","buttonContainer":"_2frok"};